module.exports = __webpack_public_path__ + "static/media/1_xs.6903b76d.png";